{
  "title": "Wind Walk",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 minute",
  "range": "30 feet",
  "components": "V, S, M (fire and holy water)",
  "duration": "8 hours",
  "description": [
    "You and up to ten willing creatures you can see within range assume a gaseous form for the duration, appearing as wisps of cloud. While in this cloud form, a creature has a flying speed of 300 feet and has resistance to damage from nonmagical weapons. The only actions a creature can take in this form are the Dash action or to revert to its normal form.",
    "Reverting takes 1 minute, during which time a creature is incapacitated and can’t move. Until the spell ends, a creature can revert to cloud form, which also requires the 1-minute transformation.",
    "If a creature is in cloud form and flying when the effect ends, the creature descends 60 feet per round for 1 minute until it lands, which it does safely. If it can’t land after 1 minute, the creature falls the remaining distance."
  ],
  "spellLists": ["druid"]
}
